import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TJ3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TJ3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_480)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H32V24H0V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V8H32V0H0Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16V24H32V16H0Z"
          fill="#409100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0201 8.62974L15.429 9.04746L15.6375 8.34746L15.0636 7.90564L15.7837 7.89074L16.0201 7.19995L16.2566 7.89074L16.9767 7.90564L16.4028 8.34746L16.6113 9.04746L16.0201 8.62974ZM13.523 9.2425L12.9318 9.66022L13.1404 8.96023L12.5665 8.5184L13.2866 8.5035L13.523 7.81272L13.7595 8.5035L14.4796 8.5184L13.9056 8.96023L14.1142 9.66022L13.523 9.2425ZM10.9896 11.4985L11.5808 11.0808L12.172 11.4985L11.9635 10.7985L12.5374 10.3567L11.8173 10.3418L11.5808 9.65102L11.3444 10.3418L10.6243 10.3567L11.1982 10.7985L10.9896 11.4985ZM10.9566 13.4638L10.3654 13.8815L10.5739 13.1815L10 12.7397L10.7201 12.7248L10.9566 12.034L11.193 12.7248L11.9131 12.7397L11.3392 13.1815L11.5477 13.8815L10.9566 13.4638ZM20.4232 13.8815L21.0144 13.4638L21.6055 13.8815L21.397 13.1815L21.9709 12.7397L21.2508 12.7248L21.0144 12.034L20.7779 12.7248L20.0578 12.7397L20.6317 13.1815L20.4232 13.8815ZM20.2514 11.0808L19.6602 11.4985L19.8687 10.7985L19.2948 10.3567L20.0149 10.3418L20.2514 9.65102L20.4878 10.3418L21.2079 10.3567L20.634 10.7985L20.8425 11.4985L20.2514 11.0808ZM17.7471 9.66022L18.3382 9.2425L18.9294 9.66022L18.7209 8.96023L19.2948 8.5184L18.5747 8.5035L18.3382 7.81272L18.1018 8.5035L17.3817 8.5184L17.9556 8.96023L17.7471 9.66022ZM12.6674 16.7545L12.483 16.0981C13.5031 15.8221 14.6741 15.6849 15.9965 15.6849C17.3188 15.6849 18.4898 15.8221 19.5099 16.0981L19.3256 16.7545C18.3694 16.4958 17.2597 16.3657 15.9965 16.3657C14.7333 16.3657 13.6235 16.4958 12.6674 16.7545ZM13.9306 15.7019C13.5236 15.7711 13.1908 15.3777 13.1908 15.3777L13.5945 15.2108C13.5817 14.9309 13.7506 14.7574 13.7506 14.7574C13.8872 14.8203 14.0735 15.164 14.0735 15.164H14.4395C14.4395 15.164 14.3376 15.6328 13.9306 15.7019ZM18.7401 15.4457C18.7401 15.4457 18.4073 15.8392 18.0003 15.77C17.5933 15.7009 17.4913 15.2321 17.4913 15.2321H17.8573C17.8573 15.2321 18.0437 14.8884 18.1803 14.8255C18.1803 14.8255 18.3491 14.999 18.3363 15.2789L18.7401 15.4457ZM15.9454 15.5773C15.5327 15.5891 15.2579 15.1532 15.2579 15.1532L15.6809 15.0442C15.7072 14.7652 15.8986 14.6169 15.8986 14.6169C16.0251 14.6982 16.1618 15.0645 16.1618 15.0645L16.5242 15.1154C16.5242 15.1154 16.358 15.5655 15.9454 15.5773Z"
          fill="#FFBB00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9588 13.6985C15.9588 13.6985 15.4898 14.7718 14.7511 14.8548C14.0125 14.9378 13.6373 14.2444 13.6373 14.2444C13.6373 14.2444 13.5889 14.9655 12.7117 15.2435C11.8345 15.5214 11.3726 14.4108 11.3726 14.4108C11.3726 14.4108 11.8293 14.8194 12.5376 14.6413C13.2459 14.4633 13.5255 13.8059 13.5255 13.8059C13.5255 13.8059 14.0497 14.4913 14.7511 14.1486C15.4525 13.8059 15.8406 13.3871 15.8406 12.9852V11.7834C15.8406 11.7834 15.6596 11.4717 15.3457 11.4717C15.0318 11.4717 14.9442 11.6927 14.9442 11.6927C14.9442 11.6927 14.8217 10.4424 15.9506 10.3651L15.9506 10.3621C15.9611 10.3624 15.9715 10.3628 15.9818 10.3633C15.9921 10.3628 16.0025 10.3624 16.013 10.3621L16.013 10.3651C17.142 10.4424 17.0194 11.6927 17.0194 11.6927C17.0194 11.6927 16.9318 11.4717 16.6179 11.4717C16.304 11.4717 16.1231 11.7834 16.1231 11.7834V12.9852C16.1231 13.3871 16.5111 13.8059 17.2125 14.1486C17.9139 14.4913 18.4381 13.8059 18.4381 13.8059C18.4381 13.8059 18.7177 14.4633 19.426 14.6413C20.1344 14.8194 20.5911 14.4108 20.5911 14.4108C20.5911 14.4108 20.1291 15.5214 19.2519 15.2435C18.3747 14.9655 18.3263 14.2444 18.3263 14.2444C18.3263 14.2444 17.9511 14.9378 17.2125 14.8548C16.4738 14.7718 16.0048 13.6985 16.0048 13.6985L15.9818 12.2819L15.9588 13.6985ZM15.9484 10.7017C15.4276 10.7017 15.3221 11.1427 15.3221 11.1427C15.7807 11.1427 15.9484 11.3426 15.9484 11.3426C15.9484 11.3426 16.2879 11.1427 16.6298 11.1427C16.6298 11.1427 16.4692 10.7017 15.9484 10.7017Z"
          fill="#FFBB00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1813_480">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TJ3224Icon;
